<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <div class="row justify-content-center">
    <h1 class="lifedi-color">
      แบบทดสอบ
    </h1>
  </div>
  <div class="row d-flex flex-row-reverse bd-highlight mb-4">
    <div class="container">
      <div class="col-lg-3 col-md-4 col-sm-5 col-12 m-2" style="float:right;">
        <div class="row d-flex">
          <label class="form-label col-lg-3 col-md-3 col-sm-12 col-12 m-auto p-0">ประเภท</label>
          <select class="custom-select form-control col-lg-9 col-md-9 col-sm-12 col-12" [(ngModel)]="selectedType" (change)="changeType()">
            <option value="0">ทั้งหมด</option>
            <option *ngFor="let item of type" [value]="item.ID">{{item.TYPE_NAME}}</option>
          </select>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-5 col-12 m-2" style="float:right;">
        <div class="row d-flex">
            <label class="form-label col-lg-3 col-md-3 col-sm-12 col-12 m-auto p-0">ตัวกรอง</label>
          <select class="custom-select form-control col-lg-9 col-md-9 col-sm-12 col-12" [(ngModel)]="filteredType" (change)="changeType()">
            <option value="0">แบบทดสอบทั้งหมด</option>
            <option value="1">แบบทดสอบที่เคยทำร่วมกับผู้อื่น</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3 mb-3" *ngIf="rows?.length === 0">
    <h4 class="text-center w-100">
      ยังไม่มีแบบทดสอบ
    </h4>
  </div>

  <div class="row" *ngIf="rows?.length > 0">
    <div *ngFor="let c of rows" class="col-lg-3 col-md-4 col-sm-6 mb-4">
      <lifedi-measure-card [data]="c" [userEmail]="userEmail"></lifedi-measure-card>
    </div>
  </div>

  <div class="d-flex justify-content-center p-2" *ngIf="rows">
    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="refresh()">
    </ngb-pagination>
  </div>
</div>